import "reflect-metadata";
import { Container } from "inversify";
import CustomersService from "../api/customer-service";
import RmaService from "../api/rma-service";
import UserMasterListService from "../api/user-master-list-service";
import EmailSettingService from "../api/email-setting-service";
import CurrencyService from "../currency-service";
import HttpService, { IHttpService } from '../http-service';
import PortalService from '../api/user-service';
import TroubleshootingService from '../api/troubleshooting-service';
import TranslationsService from "../api/translations-service";
import ReturnReasonsService from '../api/return-reasons-service';
import SubscriptionPlansService from "../api/subscription-plans-service";
import ShopifySettingsService from '../api/shopify-settings-service';
import EmailService from "../api/email-service";
import IntegrationsService from "../api/integrations-service";
import CreditsService from "../api/credits-service";
import TransactionsService from "../api/transactions-service";
import { IIframeService } from "../iframe-service/iframe-service";
import ReturngoApiService from "../api/returngo-api-service";
import ReportService from "../api/report-service";
import AddonsService from "../api/addons-service";
import BillingService from "../api/billing-service";
import AccountService from "../api/account-service";
import LocalesService from "../api/locales-service";
import ResolutionsService from "../api/resolutions-service";
import RoleService from "../api/role-service";
import EmailContentService from "../api/email-content-service";
import SettingsService from "../api/settings-service";
import DashboardTranslationsService from "../api/dashboard-translations-service";
import ShippingIntegrationsService from "../api/shipping-integrarions-service";
import ReturnMethodsService from "../api/return-methods-service";
import CustomizationsService from "../api/customizations-service";
import PolicyService from "../api/policy-service";
import PhysicalStoreService from "../api/physical-store-service";
import IsMobileService from "../is-mobile-service/is-mobile-service";
import OrderService from "../order-service";
import CreateRmaService from "../api/create-rma-service";
import ParentChildService from "../api/parent-child-service";
import RmaListService from "../api/rma-list-service";
import DevSettingsService from "../api/dev-settings-service";
import MerchantVideoService from "../api/merchant-video-service";
import DashboardService from "../api/dashboard-service";
import UISettingsService from "../api/ui-settings-service";
import RefundCalculatorService from "../api/refund-calculator-service";
import ManagersApprovalService from "../api/managers-approval-service";
import TimezoneService from "../timezone-service";
import CoverageService from "../api/coverage-service";
import ShipmentsService from "../api/shipments-service";
import OnboardingService from "../api/onboarding-service";
import TermsAcceptanceService from "../api/terms-acceptance-service";
import MixpanelService from "../mixpanel.service";
import WalletService from "../api/wallet-service";
import AdminManageMerchantsPlansService from "../api/admin-manage-merchants-plans-service";
import AdminManageMerchantWalletService from "../api/admin-manage-merchant-wallet-service";
import AppcuesService from "../appcues.service";
import ShipByReturnGoService from "../api/ship-by-returngo-service";
import CanduService from "../candu-service";
import ErrorReportingService from "../error-reporting.service";
import MerchantWarehousesZonesService from "../api/merchant-warehouses-zones-service";
import AdminMigrateGlobalEMerchantsService from "../api/admin-migrate-global-e-merchants-service";
import RmsApiConnectionManager from "../rms-api-connection-manager";

export const TYPE = {
    UserService: Symbol.for('UserService'),
    TroubleshootingService: Symbol.for('TroubleshootingService'),
    ApiHttp: Symbol.for('ApiHttp'),
    TranslationsService: Symbol.for('TranslationsService'),
    ReturnReasonsService: Symbol.for('ReturnReasonsService'),
    SubscriptionPlansService: Symbol.for('SubscriptionPlansService'),
    ShopifySettingsService: Symbol.for('ShopifySettingsService'),
    EmailService: Symbol.for('EmailService'),
    EmailContentService: Symbol.for('EmailContentService'),
    EmailSettingService: Symbol.for('EmailSettingService'),
    IntegrationsService: Symbol.for('IntegrationsService'),
    CreditsService: Symbol.for('CreditsService'),
    TransactionsService: Symbol.for('TransactionsService'),
    DashboardTranslationsService: Symbol.for('DashboardTranslationsService'),
    IframService: Symbol.for('IframService'),
    ReturngoApiService: Symbol.for('ReturngoApiService'),
    ReportService: Symbol.for('ReportService'),
    AccountService: Symbol.for('AccountService'),
    BillingService: Symbol.for('BillingService'),
    AddonsService: Symbol.for('AddonsService'),
    LocaleService: Symbol.for('LocaleService'),
    ResolutionsService: Symbol.for('ResolutionsService'),
    RoleService: Symbol.for('RoleService'),
    SettingsService: Symbol.for('SettingsService'),
    ShippingIntegrationsService: Symbol.for('ShippingIntegrationsService'),
    ReturnMethodsService: Symbol.for('ReturnMethodsService'),
    CustomizationsService: Symbol.for('CustomizationsService'),
    PolicyService: Symbol.for('PolicyService'),
    PhysicalStoreService: Symbol.for('PhysicalStoreService'),
    OrderService: Symbol.for('OrderService'),
    UserMasterListService: Symbol.for('UserMasterListService'),
    CreateRmaService: Symbol.for('CreateRmaService'),
    RmaListService: Symbol.for('RmaListService'),
    RmaService: Symbol.for('RmaService'),
    CustomersService:Symbol.for('CustomersService'),
    ParentChildService: Symbol.for('ParentChildService'),
    MerchantVideoService:Symbol.for('MerchantVideoService'),
    DevSettingsService: Symbol.for('DevSettingsService'),
    DashboardService:Symbol.for('DashboardService'),
    IsMobileService: Symbol.for('IsMobileService'),
    CurrencyService: Symbol.for('CurrencyService'),
    UISettingsService: Symbol.for('UISettingsService'),
    RefundCalculatorService: Symbol.for('RefundCalculatorService'),
    ManagersApprovalService: Symbol.for('ManagersApprovalService'),
    TimezoneService: Symbol.for('TimezoneService'),
    CoverageService: Symbol.for('CoverageService'),
    ShipmentsService: Symbol.for('ShipmentsService'),
    RmsApiHttp: Symbol.for('RmsApiHttp'),
    OnboardingService: Symbol.for('OnboardingService'),
    TermsAcceptanceService: Symbol.for('TermsAcceptanceService'),
    MixpanelService: Symbol.for('MixpanelService'),
    AdminManageMerchantsPlansService: Symbol.for('AdminManageMerchantsPlansService'),
    AdminManageMerchantWalletService: Symbol.for('AdminManageMerchantWalletService'),
    WalletService: Symbol.for('WalletService'),
    AppcuesService: Symbol.for('AppcuesService'),
    ShipByReturnGoService: Symbol.for('ShipByReturnGoService'),
    CanduService: Symbol.for('CanduService'),
    ErrorReportingService: Symbol.for('ErrorReportingService'),
    MerchantWarehousesZonesService: Symbol.for('MerchantWarehousesZonesService'),
    AdminMigrateGlobalEMerchantsService: Symbol.for('AdminMigrateGlobalEMerchantsService'),
    RmsApiConnectionManager: Symbol.for('RmsApiConnectionManager'),
}

let rootContainer: Container = new Container();

export function initContainer(iframeService: IIframeService, errorReportingService: ErrorReportingService, apiUrl?: string, rmsApiUrl?: string) {

    rootContainer.bind<IIframeService>(TYPE.IframService).toConstantValue(iframeService);
    rootContainer.bind<ErrorReportingService>(TYPE.ErrorReportingService).toConstantValue(errorReportingService);

    /** create single configured instance of api http service */
    rootContainer.bind<IHttpService>(TYPE.ApiHttp).toConstantValue(
        new HttpService(apiUrl, true, iframeService)
    );

    rootContainer.bind<IHttpService>(TYPE.RmsApiHttp).toConstantValue(
        new HttpService(rmsApiUrl, true, iframeService)
    );

    rootContainer.bind<MixpanelService>(TYPE.MixpanelService).toConstantValue(
        new MixpanelService()
    );

    rootContainer.bind<PortalService>(TYPE.UserService).to(PortalService).inSingletonScope();
    rootContainer.bind<TroubleshootingService>(TYPE.TroubleshootingService).to(TroubleshootingService).inSingletonScope();
    rootContainer.bind<TranslationsService>(TYPE.TranslationsService).to(TranslationsService).inSingletonScope();
    rootContainer.bind<DashboardTranslationsService>(TYPE.DashboardTranslationsService).to(DashboardTranslationsService).inSingletonScope();
    rootContainer.bind<ReturnReasonsService>(TYPE.ReturnReasonsService).to(ReturnReasonsService).inSingletonScope();
    rootContainer.bind<SubscriptionPlansService>(TYPE.SubscriptionPlansService).to(SubscriptionPlansService).inSingletonScope();
    rootContainer.bind<ShopifySettingsService>(TYPE.ShopifySettingsService).to(ShopifySettingsService).inSingletonScope();
    rootContainer.bind<EmailService>(TYPE.EmailService).to(EmailService).inSingletonScope();
    rootContainer.bind<EmailContentService>(TYPE.EmailContentService).to(EmailContentService).inSingletonScope();
    rootContainer.bind<EmailSettingService>(TYPE.EmailSettingService).to(EmailSettingService).inSingletonScope();
    rootContainer.bind<IntegrationsService>(TYPE.IntegrationsService).to(IntegrationsService).inSingletonScope();
    rootContainer.bind<CreditsService>(TYPE.CreditsService).to(CreditsService).inSingletonScope();
    rootContainer.bind<TransactionsService>(TYPE.TransactionsService).to(TransactionsService).inSingletonScope();
    rootContainer.bind<ReturngoApiService>(TYPE.ReturngoApiService).to(ReturngoApiService).inSingletonScope();
    rootContainer.bind<ReportService>(TYPE.ReportService).to(ReportService).inSingletonScope();
    rootContainer.bind<AccountService>(TYPE.AccountService).to(AccountService).inSingletonScope();
    rootContainer.bind<BillingService>(TYPE.BillingService).to(BillingService).inSingletonScope();
    rootContainer.bind<AddonsService>(TYPE.AddonsService).to(AddonsService).inSingletonScope();
    rootContainer.bind<LocalesService>(TYPE.LocaleService).to(LocalesService).inSingletonScope();
    rootContainer.bind<ResolutionsService>(TYPE.ResolutionsService).to(ResolutionsService).inSingletonScope();
    rootContainer.bind<RoleService>(TYPE.RoleService).to(RoleService).inSingletonScope();
    rootContainer.bind<SettingsService>(TYPE.SettingsService).to(SettingsService).inSingletonScope();
    rootContainer.bind<ShippingIntegrationsService>(TYPE.ShippingIntegrationsService).to(ShippingIntegrationsService).inSingletonScope();
    rootContainer.bind<ReturnMethodsService>(TYPE.ReturnMethodsService).to(ReturnMethodsService).inSingletonScope();
    rootContainer.bind<CustomizationsService>(TYPE.CustomizationsService).to(CustomizationsService).inSingletonScope();
    rootContainer.bind<PolicyService>(TYPE.PolicyService).to(PolicyService).inSingletonScope();
    rootContainer.bind<PhysicalStoreService>(TYPE.PhysicalStoreService).to(PhysicalStoreService).inSingletonScope();
    rootContainer.bind<OrderService>(TYPE.OrderService).to(OrderService).inSingletonScope();
    rootContainer.bind<UserMasterListService>(TYPE.UserMasterListService).to(UserMasterListService).inSingletonScope();
    rootContainer.bind<CreateRmaService>(TYPE.CreateRmaService).to(CreateRmaService).inSingletonScope();
    rootContainer.bind<RmaListService>(TYPE.RmaListService).to(RmaListService).inSingletonScope();
    rootContainer.bind<RmaService>(TYPE.RmaService).to(RmaService).inSingletonScope();
    rootContainer.bind<CustomersService>(TYPE.CustomersService).to(CustomersService).inSingletonScope();
    rootContainer.bind<ParentChildService>(TYPE.ParentChildService).to(ParentChildService).inSingletonScope();
    rootContainer.bind<MerchantVideoService>(TYPE.MerchantVideoService).to(MerchantVideoService).inSingletonScope();
    rootContainer.bind<DevSettingsService>(TYPE.DevSettingsService).to(DevSettingsService).inSingletonScope();
    rootContainer.bind<DashboardService>(TYPE.DashboardService).to(DashboardService).inSingletonScope();
    rootContainer.bind<IsMobileService>(TYPE.IsMobileService).to(IsMobileService).inSingletonScope();
    rootContainer.bind<CurrencyService>(TYPE.CurrencyService).to(CurrencyService).inSingletonScope();
    rootContainer.bind<UISettingsService>(TYPE.UISettingsService).to(UISettingsService).inSingletonScope();
    rootContainer.bind<RefundCalculatorService>(TYPE.RefundCalculatorService).to(RefundCalculatorService).inSingletonScope();
    rootContainer.bind<ManagersApprovalService>(TYPE.ManagersApprovalService).to(ManagersApprovalService).inSingletonScope();
    rootContainer.bind<TimezoneService>(TYPE.TimezoneService).toConstantValue(new TimezoneService());
    rootContainer.bind<CoverageService>(TYPE.CoverageService).to(CoverageService).inSingletonScope();
    rootContainer.bind<ShipmentsService>(TYPE.ShipmentsService).to(ShipmentsService).inSingletonScope();
    rootContainer.bind<OnboardingService>(TYPE.OnboardingService).to(OnboardingService).inSingletonScope();
    rootContainer.bind<TermsAcceptanceService>(TYPE.TermsAcceptanceService).to(TermsAcceptanceService).inSingletonScope();
    rootContainer.bind<WalletService>(TYPE.WalletService).to(WalletService).inSingletonScope();
    rootContainer.bind<AdminManageMerchantsPlansService>(TYPE.AdminManageMerchantsPlansService).to(AdminManageMerchantsPlansService).inSingletonScope();
    rootContainer.bind<AdminManageMerchantWalletService>(TYPE.AdminManageMerchantWalletService).to(AdminManageMerchantWalletService).inSingletonScope();
    rootContainer.bind<AppcuesService>(TYPE.AppcuesService).to(AppcuesService).inSingletonScope();
    rootContainer.bind<ShipByReturnGoService>(TYPE.ShipByReturnGoService).to(ShipByReturnGoService).inSingletonScope();
    rootContainer.bind<CanduService>(TYPE.CanduService).to(CanduService).inSingletonScope();
    rootContainer.bind<MerchantWarehousesZonesService>(TYPE.MerchantWarehousesZonesService).to(MerchantWarehousesZonesService).inSingletonScope();
    rootContainer.bind<AdminMigrateGlobalEMerchantsService>(TYPE.AdminMigrateGlobalEMerchantsService).to(AdminMigrateGlobalEMerchantsService).inSingletonScope();
    rootContainer.bind<RmsApiConnectionManager>(TYPE.RmsApiConnectionManager).to(RmsApiConnectionManager).inSingletonScope();
}

export {
    rootContainer,
};
